var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopeGroupWrite = function SvgScopeGroupWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M1 13v-1.333c0-1.243.85-2.287 2-2.583m2.333-7.89a2.668 2.668 0 0 0 0 4.945m3 2.861C7.091 9 6.47 9 5.98 9.203c-.654.27-1.173.79-1.444 1.443-.203.49-.203 1.111-.203 2.354m2.334-9.333a2.667 2.667 0 1 0 5.333 0 2.667 2.667 0 0 0-5.333 0M9.117 12.95c.014-.129.021-.193.04-.253a.6.6 0 0 1 .073-.15c.035-.053.08-.099.172-.19l4.1-4.1a.878.878 0 0 1 1.24 1.242l-4.099 4.1a1.3 1.3 0 0 1-.19.171.6.6 0 0 1-.15.072c-.06.02-.124.027-.252.041L9 14z"
  })));
};
export default SvgScopeGroupWrite;